import type { EarningsPresentationVariant } from '../utils';
import styles from './EarningsReportingSummary.module.scss';
import { ReportedTodayCard } from './ReportedTodayCard';
import { ReportingThisWeekCard } from './ReportingThisWeekCard';
import type {
  EarningsTopicClickHandler,
  GuidanceDirection,
  ReportedTodayRow,
  ReportingThisWeekRow,
} from './types';

interface EarningsReportingSummaryProps {
  reportedToday: ReportedTodayRow[];
  reportingThisWeek: ReportingThisWeekRow[];
  guidanceByEarningsId: Map<string, GuidanceDirection>;
  onTopicClick: EarningsTopicClickHandler;
  variant?: EarningsPresentationVariant;
}

export const EarningsReportingSummary = ({
  reportedToday,
  reportingThisWeek,
  guidanceByEarningsId,
  onTopicClick,
  variant = 'page',
}: EarningsReportingSummaryProps) => {
  const hasReportedToday = reportedToday.length > 0;
  const hasReportingThisWeek = reportingThisWeek.length > 0;

  if (!hasReportedToday && !hasReportingThisWeek) {
    return null;
  }

  return (
    <div className={styles.root} data-testid="earnings-reporting-summary">
      {hasReportedToday && (
        <ReportedTodayCard
          rows={reportedToday}
          guidanceByEarningsId={guidanceByEarningsId}
          onTopicClick={onTopicClick}
          variant={variant}
        />
      )}
      {hasReportingThisWeek && (
        <ReportingThisWeekCard
          rows={reportingThisWeek}
          onTopicClick={onTopicClick}
          variant={variant}
        />
      )}
    </div>
  );
};
